export default {"src":"https://filecdn-other.xingyeai.com/xingye-ugc/_next/static/media/info.05850b09.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};